<template>
  <div class="shop-detail-container">
    <div class="white-bg padding border-radius-top">
      <div class="flex justify-between">
        <div class="text-title">
          {{ $t('aShop.shopInfo') }}
        </div>
        <div></div>
      </div>

      <!-- 店铺信息 -->
      <div class="margin-top">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('aShop.shopName') }}：
              </label>
              <label>{{ aShopDetailInfo.shopName }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('aShop.shopType') }}：
              </label>
              <label>{{ aShopDetailInfo.shopTypeName || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('aShop.merchantName') }}：
              </label>
              <label>{{ aShopDetailInfo.storeName }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('aShop.merchantAddress') }}：
              </label>
              <label>{{ aShopDetailInfo.storeAddress || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                退货电话：
              </label>
              <label>{{ aShopDetailInfo.returnLink || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('aShop.shopStatus') }}：
              </label>
              <label>{{ aShopDetailInfo.stateName || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('aShop.createTime') }}：
              </label>
              <label>{{ aShopDetailInfo.createTime || '-' }}</label>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="vc-line-primary margin-top"></div>

      <div class="margin-top-sm">
        <el-tabs v-model="aShopDetailInfo._currentTab" @tab-click="changeTab(aShopDetailInfo._currentTab)">
          <el-tab-pane label="商品" name="aShopDetailProduct" v-if="aShopDetailInfo.shopTypeCate=='1' || aShopDetailInfo.shopTypeCate=='2'"></el-tab-pane>
          <el-tab-pane label="商品分组" name="aShopDetailCategory"  v-if="aShopDetailInfo.shopTypeCate=='1' || aShopDetailInfo.shopTypeCate=='2'"></el-tab-pane>
          <el-tab-pane label="仓库" name="aShopDetailHouse" v-if="aShopDetailInfo.shopTypeCate=='1' || aShopDetailInfo.shopTypeCate=='2'"></el-tab-pane>
          <el-tab-pane label="便民服务" name="aShopDetailServ" v-if="aShopDetailInfo.shopTypeCate=='3'"></el-tab-pane>
<!--          <el-tab-pane label="入库记录" name="aShopDetailInstock"></el-tab-pane>-->
<!--          <el-tab-pane label="出库记录" name="aShopDetailOutstock"></el-tab-pane>-->
<!--          <el-tab-pane label="会员" name="aShopDetailVip"></el-tab-pane>-->
          <el-tab-pane label="订单" name="aShopDetailOrder"></el-tab-pane>
          <el-tab-pane label="退货" name="aShopDetailRefundOrder"></el-tab-pane>
<!--          <el-tab-pane label="拼团商品" name="aShopDetailGroup"></el-tab-pane>-->
<!--          <el-tab-pane label="拼团订单" name="aShopDetailGroupOrders"></el-tab-pane>-->
<!--          <el-tab-pane label="拼团退单" name="aShopDetailRefundGOrders"></el-tab-pane>-->
          <el-tab-pane label="秒杀商品" name="aShopDetailSeckill" v-if="aShopDetailInfo.shopTypeCate=='1' || aShopDetailInfo.shopTypeCate=='2'"></el-tab-pane>
          <el-tab-pane label="秒杀订单" name="aShopDetailSeckillOrders" v-if="aShopDetailInfo.shopTypeCate=='1' || aShopDetailInfo.shopTypeCate=='2'"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="white-bg padding-left padding-right border-radius-bottom">
      <component :is="aShopDetailInfo._currentTab" :ref="aShopDetailInfo._currentTab" :shopId="aShopDetailInfo.shopId"></component>
    </div>
  </div>
</template>

<script>
import { queryShopsByAdmin } from '@/api/shop/shopApi'
import aShopDetailProduct from '@/components/goods/aShopDetailProduct'
import aShopDetailCategory from '@/components/shop/aShopDetailCategory'
import aShopDetailHouse from '@/components/shop/aShopDetailHouse'
import aShopDetailServ from '@/components/housekeeping/aShopDetailServ'
import aShopDetailInstock from '@/components/goods/aShopDetailInstock'
import aShopDetailOutstock from '@/components/goods/aShopDetailOutstock'
import aShopDetailVip from '@/components/user/aShopDetailVip'
import aShopDetailOrder from '@/components/order/aShopDetailOrder'
import aShopDetailRefundOrder from '@/components/order/aShopDetailRefundOrder'
import aShopDetailGroup from '@/components/group/aShopDetailGroup'
import aShopDetailGroupOrders from '@/components/order/aShopDetailGroupOrders'
import aShopDetailRefundGOrders from '@/components/order/aShopDetailRefundGOrders'
import aShopDetailSeckill from '@/components/goods/aShopDetailSeckill'
import aShopDetailSeckillOrders from '@/components/order/aShopDetailSeckillOrders'

export default {
  name: 'AShopDetail',
  components: {
    aShopDetailProduct,
    aShopDetailCategory,
    aShopDetailHouse,
    aShopDetailServ,
    aShopDetailInstock,
    aShopDetailOutstock,
    aShopDetailVip,
    aShopDetailOrder,
    aShopDetailRefundOrder,
    aShopDetailGroup,
    aShopDetailGroupOrders,
    aShopDetailRefundGOrders,
    aShopDetailSeckill,
    aShopDetailSeckillOrders
  },
  data() {
    return {
      aShopDetailInfo: {
        shopId: '',
        shopName: '',
        shopTypeName: '',
        storeName: '',
        storeAddress: '',
        returnLink: '',
        stateName: '',
        createTime: '',
        _currentTab: 'aShopDetailProduct',
          shopTypeCate: '1'
      }
    }
  },
  created() {
    this.aShopDetailInfo.shopId = this.$route.query.shopId
    if (!this.aShopDetailInfo.shopId) {
      return
    }
    this.listAShopDetail()
  },
  methods: {
    async listAShopDetail() {
      try {
        const res = await queryShopsByAdmin({
          shopId: this.aShopDetailInfo.shopId,
          page: 1,
          row: 1
        })
        Object.assign(this.aShopDetailInfo, res.data[0])
        this.changeTab(this.aShopDetailInfo._currentTab)
      } catch (error) {
        console.error('获取店铺详情失败:', error)
      }
    },
    changeTab(tab) {
      this.aShopDetailInfo._currentTab = tab
      setTimeout(() => {
        this.$refs[tab].open({
          shopId: this.aShopDetailInfo.shopId
        })
      }, 500)
    }
  }
}
</script>

<style scoped>
.shop-detail-container {
  background-color: #f5f5f5;
}
.white-bg {
  background-color: #fff;
}
.padding-left {
  padding-left: 20px;
}
.padding-right {
  padding-right: 20px;
}
.padding-top {
  padding-top: 20px;
}
.border-radius-top {
  border-radius: 4px 4px 0 0;
}
.border-radius-bottom {
  border-radius: 0 0 4px 4px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.text-title {
  font-size: 18px;
  font-weight: bold;
}
.margin-top {
  margin-top: 20px;
}
.margin-top-sm {
  margin-top: 10px;
}
.vc-line-primary {
  height: 1px;
  background-color: #dcdfe6;
}
.form-group {
  margin-bottom: 15px;
}
.col-form-label {
  display: inline-block;
  margin-right: 10px;
  color: #606266;
}
</style>